function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "CV");

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.234,
    height: 28.006,
    viewBox: "0 0 24.234 28.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10246"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.617 21.005)",
    style: {
      fontSize: 11,
      fontFamily: "Helvetica",
      fill: "#65676f"
    }
  }, _ref2), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 37",
    d: "M2428.4 16579.746a4.386 4.386 0 0 1-4.382-4.381v-19.045a4.386 4.386 0 0 1 4.382-4.381h11.684a7.784 7.784 0 0 1 5.655 2.646 8.089 8.089 0 0 1 2.313 5.271v15.508a4.386 4.386 0 0 1-4.382 4.381zm-1.827-23.426v19.045a1.829 1.829 0 0 0 1.827 1.826h15.271a1.829 1.829 0 0 0 1.827-1.826v-13.244h-2.838a4.868 4.868 0 0 1-4.86-4.865v-2.762h-9.4a1.828 1.828 0 0 0-1.831 1.826zm13.831.936a2.261 2.261 0 0 0 2.255 2.26h2.82a6.154 6.154 0 0 0-5.075-5.01z",
    transform: "translate(-2423.914 -16551.839)",
    style: {
      stroke: "#fff",
      strokeWidth: ".2px",
      fill: "#65676f"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.95fbf4c1.svg";
export { ForwardRef as ReactComponent };